module.exports = __webpack_public_path__ + "static/media/Servietten_40x40.c9c430fe.png";